import { isValidPhoneNumber } from 'libphonenumber-js';

export function isValidPhone(value: string | undefined): boolean {
  if (!value) return false;
  try {
    return isValidPhoneNumber(value);
  } catch {
    return false;
  }
}

export function isPhoneEmpty(value: string | undefined): boolean {
  if (!value) return true;
  const digits = value.replace(/[^+\d]/g, '');
  return !digits || /^\+\d{1,3}$/.test(digits);
}
